module.exports = __webpack_public_path__ + "img/Step1.f02d8c7.svg";